import { render, staticRenderFns } from "./auth-forget-password.vue?vue&type=template&id=2222b562&"
import script from "./auth-forget-password.vue?vue&type=script&lang=js&"
export * from "./auth-forget-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports